import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faAddressBook, faClock } from '@fortawesome/free-regular-svg-icons';
import moment from 'moment';

const AddressSelect = ({
  onDropChange,
  onInputChange,
  options,
  optName,
  optVal,
  curVal,
  useId,
  disabled,
  assetType,
  useDropdown,
  clearAddress,
  erc20,
  pattern,
  title,
  whitelistEnabled
}) => {
  const node = useRef();

  const [open, setOpen] = useState(false);

  const handleClickOutside = (e) => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location]);

  const handleOnDropChange = (item) => {
    const data = {
      useId,
      item
    }
    onDropChange(data);
    setOpen(false);
  };

  let useOptions;
  let optionLoop = (
    <div className="dpo-i">
      <div className="drop-label">
        <p>
          No Saved addresses.
        </p>
      </div>
    </div>
  );

  let current;
  let dropClass = 'drop-con dc-address';

  const now = moment();

  if (options && options.length) {
    if (optVal && curVal) {
      current = options.find((item) => item[optVal] === curVal);
    }
    if (assetType) {
      useOptions = options.filter((item) => item.typeHandle === assetType);
    }
    // if (optName && optVal && current && useOptions) {
    if (optName && optVal) {
      if (useOptions && useOptions.length) {
        optionLoop = useOptions.map((item) => {
          let createdAt;
          let deadline;
          let isOld;
          // let difference;
          if (item.createdAt) {
            createdAt = moment(item.createdAt);
          }
          if (createdAt) {
            deadline = moment(createdAt).add(2,'day');
          }
          if (deadline) {
            isOld = moment(now).isSameOrAfter(deadline);
          }
          // if (now && deadline) {
          //   difference = moment(now.diff(deadline)).format("HH:mm:ss");
          // }
          return (
            <div
              key={item[optVal]}
              data-value={item}
              className="dpo-i"
              onClick={() => handleOnDropChange(item)}
            >
              <div className="drop-label">
                <p>
                  {isOld ? null : (
                    <span>
                      <span className="dc-ad-new">
                        NEW&nbsp;
                      </span>
                    </span>
                  )}
                  {item[optName]}
                </p>
                <p>
                  {item[optVal]}
                </p>
              </div>
            </div>
          )
        });
      }
    }
  }

  let createdAt;
  let deadline;
  let isOld;
  if (current) {
    if (current.createdAt) {
      createdAt = moment(current.createdAt);
    }
    if (createdAt) {
      deadline = moment(createdAt).add(2,'day');
    }
    if (deadline) {
      isOld = moment(now).isSameOrAfter(deadline);
    }
  }

  if (useDropdown) {
    return (
      <div className={dropClass} ref={node}>
        <div className="drop-sel">
          { current && (
            <>
              {current[optVal] && (
                <>
                  <div className="drop-icon">
                    <FontAwesomeIcon
                      icon={faAddressBook}
                    />
                  </div>
                  <div className="drop-label">
                    <p>
                      {isOld ? null : (
                        <span className="dc-ad-new">
                          NEW&nbsp;
                        </span>
                      )}
                      {current[optName]}
                    </p>
                    <p>
                      {current[optVal]}
                    </p>
                  </div>
                </>
              )}
            </>
          )}
        </div>
        <div className="drop-action" onClick={() => clearAddress()}>
          <FontAwesomeIcon
            icon={faTimes}
          />
        </div>
        {open && (
          <div className="drop-opts">
            {optionLoop}
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <div
        className={dropClass}
        ref={node}
        onClick={ whitelistEnabled ? (
          () => setOpen(!open)
        ) : (
          undefined
        )}
        style={ whitelistEnabled ? (
          {cursor: 'pointer'}
        ) : (
          {}
        )}
      >
        {whitelistEnabled ? (
          <div className={erc20 ? 'drop-inp erc20' : 'drop-inp'}>
            <span className="d-i-place">Select address from dropdown</span>
          </div>
        ) : (
          <div className={erc20 ? 'drop-inp erc20' : 'drop-inp'}>
            <input
              type="text"
              name="useAddress"
              placeholder={erc20 ? '' : 'Address'}
              id="useAddress"
              value={curVal || ''}
              onChange={onInputChange}
              pattern={pattern}
              title={title}
            />
            {erc20 ? (
              <span>0x</span>
            ) : (
              null
            )}
          </div>
        )}
        <div
          className="drop-action"
          onClick={ whitelistEnabled ? (
            undefined
          ) : (
            () => setOpen(!open)
          )}
        >
          <FontAwesomeIcon
            icon={faChevronDown}
          />
        </div>
        {open && (
          <div className="drop-opts">
            {optionLoop}
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

AddressSelect.propTypes = {
  onDropChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  optName: PropTypes.string.isRequired,
  optVal: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  curVal: PropTypes.string.isRequired,
  useDropdown: PropTypes.bool.isRequired,
  useId: PropTypes.string.isRequired,
  assetType: PropTypes.string.isRequired,
  clearAddress: PropTypes.func.isRequired,
  erc20: PropTypes.bool.isRequired,
  pattern: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  whitelistEnabled: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(AddressSelect);
